import { Action } from "redux";
import { ThunkAction } from "redux-thunk";
import { AppState } from ".";
import { SmsCodeService } from "../service/sms-code.service";
import { CODE_SUBMITED, SEND_SMS_CODE_AGAIN_VALIDATION_ERROR, SUBMIT_CODE_AGAIN } from "./actions/code-actions";

export const submitSmsCodeAgain = (): ThunkAction<void, AppState, unknown, Action<any>> => async (dispatch) => {
  const service = new SmsCodeService()

  await dispatch({ type: SUBMIT_CODE_AGAIN })

  service.submitAgainSmsCode().then(async (p) => {
    await dispatch({
      type: CODE_SUBMITED,
      payload: p.isLimit,
    });
  }).catch(async e => {
    await dispatch({
      type: SEND_SMS_CODE_AGAIN_VALIDATION_ERROR
    })
  });
};
